import { Injectable } from "@angular/core";
import { DataService as CoreDataService } from "@barthauer/abc/core/data";
import { AbcConfigService } from "@barthauer/abc/core/configuration";
import { Observable } from "rxjs";
import { IUserInfo } from "@barthauer/custom/xmt-models";
@Injectable({
  providedIn: 'root',
})
export class LandingPageService {
  public readonly getUserLoginWebApi: string;
  public readonly setUserActiveWebApi: string;
  public readonly enableEmailNotification: string;
  private readonly ENABLE_EMAIL_NOTIFICATION_DESIGNATION = 'personEmailNotificationSettings';

  constructor(
    private coreDataService: CoreDataService,
    private configService: AbcConfigService
  ) {
    const currentCongfiguration = configService.getConfiguration();
    this.getUserLoginWebApi = currentCongfiguration.WebApi.ServiceURLs.GetUserLogin;
    this.setUserActiveWebApi = currentCongfiguration.WebApi.ServiceURLs.SetPersonStatus;
    this.enableEmailNotification = currentCongfiguration.WebApi.ServiceURLs.EnableEmailNotification;
  }

  public getUserLogin(userInfo: IUserInfo): Observable<ArrayBuffer> {
    return this.coreDataService.executeWebApiPOSTMethod(this.getUserLoginWebApi, userInfo);
  }

  public setUserActive(userInfo: IUserInfo): Observable<ArrayBuffer> {
    return this.coreDataService.executeWebApiPOSTMethod(this.setUserActiveWebApi, userInfo);
  }

 public enableEmailNotificationSettings(
  userId: string,
  designation: string = this.ENABLE_EMAIL_NOTIFICATION_DESIGNATION
): Observable<ArrayBuffer> {
  return this.coreDataService.executeWebApiPOSTMethod(
    this.enableEmailNotification,
    { UserId: userId, PropretyDesignation: designation }
  );
}
}
